window.VCA = window.VCA || {};

window.VCA.ccdeDatalayer = (function ($) {

    if ($('.ccde__wrapper').length <= 0) {
        return;
    }

    function datalayerPushStepChange(data, currentPage, previousPageName) {

        let extraData =[
            'petSpecies',
            'petBreed',
            'petGender',
            'planid',
            'zip',
            'petAgeDataLayerFormat'
        ]

        let stepInfo = {
            'event': 'ccde-pageview',
            'current-page-name': currentPage,
            'previous-page-name': previousPageName,
            'Logged-in-status': data.isLoggedIn,
            'hospital-name': data.hospitalName,
            'hospital-type': data.hospitalType,
            'hopital-AAU': data.hospitalIDValue,
            'petSpecies': '',
            'petBreed': '',
            'petGender': '',
            'planid': '',
            'zip': '',
            'petAgeDataLayerFormat': ''
        };

         extraData.forEach((dataPoint) => {
            if(data[dataPoint] !== '' && data[dataPoint] !== null) {
                stepInfo[dataPoint] = data[dataPoint];
            }
        }) 

        // console.log('stepInfo', stepInfo);
        //push to datalayer step-1
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(stepInfo);
    }

    function datalayerPushAbandon(data, currentPage, btnName) {

        let extraData =[
            'petSpecies',
            'petBreed',
            'petGender',
            'planid',
            'zip',
            'petAgeDataLayerFormat'
        ]

        let stepInfo = {
            'event': 'ccde-abandon',
            'current-page-name': currentPage,
            'Button': btnName,
            'Logged-in-status': data.isLoggedIn,
            'hospital-name': data.hospitalName,
            'hospital-type': data.hospitalType,
            'hopital-AAU': data.hospitalIDValue,
            'petSpecies': '',
            'petBreed': '',
            'petGender': '',
            'planid': '',
            'zip': '',
            'petAgeDataLayerFormat': ''
        };

         extraData.forEach((dataPoint) => {
            if(data[dataPoint] !== '' && data[dataPoint] !== null) {
                stepInfo[dataPoint] = data[dataPoint];
            }
        }) 


        //push to datalayer abandon
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(stepInfo);
    }


    return {
        datalayerPushStepChange: datalayerPushStepChange,
        datalayerPushAbandon: datalayerPushAbandon
    };



})(jQuery);